import { useState, type CSSProperties } from "react";
import type { AgentInstance } from "./api";
import { IndependentAgent } from "./IndependentAgent";
import { Icon } from "../components/Icon";

export function AgentParallel({ agents }: { agents: AgentInstance[] }) {
  const requested = new URLSearchParams(location.hash.split("?")[1]).getAll("agent");
  const selected = agents.filter(agent => requested.includes(agent.id));
  const [hidden, setHidden] = useState<string[]>([]);
  return <section className="hub-parallel">
    <header className="hub-page-head"><h1>并排工作</h1>
      <a className="btn" href="/#/agents"><Icon name="agent" />选择 IP</a></header>
    {hidden.length ? <div className="wall-dock">{selected.filter(agent => hidden.includes(agent.id)).map(agent =>
      <button key={agent.id} className="btn" type="button" onClick={() => setHidden(old => old.filter(id => id !== agent.id))}>展开 {agent.name}</button>)}</div> : null}
    {selected.length ? <div className="independent-agents" style={{ "--open-agent-count": Math.min(2, Math.max(1, selected.filter(agent => !hidden.includes(agent.id)).length)) } as CSSProperties}>{selected.map(agent => <IndependentAgent key={agent.id}
      agent={agent} hidden={hidden.includes(agent.id)} onDock={() => setHidden(old => [...old, agent.id])} />)}</div>
      : <div className="hub-empty"><h2>先选好要并排的 IP</h2><p>在「我的 IP」里勾选几个，再并排打开它们的界面。</p><a className="btn btn-accent" href="/#/agents">去选 IP</a></div>}
  </section>;
}
